<template>
  <div class="app-container center">
    <img
      :src="company"
      alt=""
    >
  </div>
  <!-- <el-calendar v-model="value" /> -->
</template>

<script>
import company from '@/assets/images/company.png'
export default {
  name: 'Dashboard',
  data() {
    return {
      value: new Date(),
      company: company
    }
  }
}
</script>

<style lang="less" scoped>
.center {
  height: 75%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
